<template>
  <div class="setup">
    <div class="setup__bike">
      <BikeIllustration />
    </div>
    <div class="setup__content">
      <TitleBar :title="t('setup.title')">
        <BfButton
          :type="ButtonType.Outlined"
          icon="/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg"
          @click="previous"
        >
          {{ t('common.previous') }}
        </BfButton>
        <BfButton
          :icon-position="ButtonIconPosition.Right"
          :state="
            hasHardwareSelected ? ButtonState.Enabled : ButtonState.Disabled
          "
          icon="/icons/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg"
          @click="next"
        >
          {{ t('common.next') }}
        </BfButton>
      </TitleBar>

      <BfInfoCard :title="t('setup.hardware.notice.index')">
        {{ t('setup.hardware.notice.content') }}
      </BfInfoCard>

      <div class="setup__hardware">
        <CurrentHardware />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ButtonType,
  ButtonState,
  BfButton,
  BfInfoCard,
  ButtonIconPosition,
} from '@finetic/bikefitting-ui'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'
import TitleBar from '@/components/layout/TitleBar.vue'
import CurrentHardware from '@/components/setup/CurrentHardware.vue'
import BikeIllustration from '@/components/preview/common/BikeIllustration.vue'

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { firstMeasurement, selectedMeasurement } = storeToRefs(measurementStore)

const previous = () => {
  router.push({ name: 'start' })
}

const next = () => {
  if (!firstMeasurement.value.handlebar.active) {
    // When going to analysis-view (step 3) for first time, fill first measurement with current hardware.
    // Check if a handlebar (could also be saddle) has been selected. If not, add hardware.

    measurementStore.updateHardware(0, {
      crankset: {
        active: selectedMeasurement.value?.crankset.active,
      },
      handlebar: {
        active: selectedMeasurement.value?.handlebar.active,
      },
      saddle: {
        active: selectedMeasurement.value?.saddle.active,
      },
      pedal: {
        active: selectedMeasurement.value?.pedal.active,
      },
    })
  }

  router.push({ name: 'analysis' })
}

const hasHardwareSelected = computed(() => {
  return (
    selectedMeasurement.value.saddle.active &&
    selectedMeasurement.value.handlebar.active &&
    selectedMeasurement.value.crankset.active &&
    selectedMeasurement.value.pedal.active
  )
})
</script>

<style lang="scss">
.setup {
  display: grid;
  grid-template-columns: 40% 60%;
  height: 100%;

  &__bike {
    background-color: #f5f5f5;
  }

  &__content {
    background-color: #fbfbfb;
    padding: 2.4rem;
  }

  &__hardware {
    margin-top: 2.4rem;
  }
}
</style>
